import React, { FC, ReactNode, useMemo } from "react";
import { InteractionType, PublicClientApplication } from "@azure/msal-browser";
import { MsalAuthenticationTemplate, MsalProvider } from "@azure/msal-react";
import {
  AccessTokenContextProvider,
  MockUser,
  User,
} from "shared-ts-utils-authentication";
import { MsalContentProtector } from "./MsalContentProtector";

const demoUser: User = new MockUser({
  id: "demo",
  name: "Demo",
  email: "demo@airmont.no",
  accessToken: "demo",
  role: "admin",
  claims: [],
});

export interface MsalAuthenticationProps {
  tenantId?: string;
  clientId: string;
  scopes?: Array<string>;
  method: InteractionType;
  predicate: () => boolean;
  authenticated: (user: User) => ReactNode;
  unauthenticated: () => ReactNode;
}

export const MsalAuthentication: FC<MsalAuthenticationProps> = (props) => {
  const pca = useMemo(() => {
    const authority =
      props.tenantId != null
        ? "https://login.microsoftonline.com/" + props.tenantId
        : "";
    return new PublicClientApplication({
      auth: {
        clientId: props.clientId,
        authority: authority,
        redirectUri: window.location.origin,
        navigateToLoginRequestUrl: true
      },
    });
  }, [props.clientId, props.tenantId]);

  if (props.predicate()) {
    return (
      <MsalProvider instance={pca}>
        <MsalAuthenticationTemplate interactionType={props.method}>
          <MsalContentProtector
            tenantId={props.tenantId}
            clientId={props.clientId}
            method={props.method}
            scopes={props.scopes}
            authenticated={props.authenticated}
            unauthenticated={props.unauthenticated}
          />
        </MsalAuthenticationTemplate>
      </MsalProvider>
    );
  } else {
    return (
      <AccessTokenContextProvider token={"demo"}>
        {props.authenticated(demoUser)}
      </AccessTokenContextProvider>
    );
  }
};
